import Homepage from './Homepage'
import { hot } from 'react-hot-loader'

class Atlas extends Homepage { }

export default hot(module)(Atlas)
